/**
 * Platform detection for PWA install behavior.
 * Mobile-only install UI; desktop always navigates.
 */

const MOBILE_UA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

/**
 * @returns {boolean} True if the current device appears to be a mobile browser.
 */
export function isMobileBrowser() {
  if (typeof navigator === 'undefined') return false;
  if (navigator.userAgentData?.mobile !== undefined) {
    return navigator.userAgentData.mobile === true;
  }
  return MOBILE_UA.test(navigator.userAgent);
}

/**
 * @returns {boolean} True if the user agent indicates Android.
 */
export function isAndroid() {
  if (typeof navigator === 'undefined') return false;
  return /Android/i.test(navigator.userAgent);
}

/**
 * @returns {boolean} True if the user agent indicates iOS (iPhone, iPad, iPod).
 */
export function isIos() {
  if (typeof navigator === 'undefined') return false;
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

/**
 * iOS Safari only (excludes Chrome, Firefox, Edge etc. on iOS).
 * @returns {boolean} True if likely Safari on iOS.
 */
export function isIosSafari() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  if (!/iPhone|iPad|iPod/i.test(ua)) return false;
  // Exclude Chromium-based and other browsers that don't support Add to Home Screen the same way
  if (/CriOS|FxiOS|EdgiOS|OPiOS|SamsungBrowser/i.test(ua)) return false;
  return true;
}
